import type FolderInfoResponseMessage from 'owa-service/lib/contract/FolderInfoResponseMessage';
import type PropertyUpdate from 'owa-service/lib/contract/PropertyUpdate';
import updateFolderRequest from 'owa-service/lib/factory/updateFolderRequest';
import folderId from 'owa-service/lib/factory/folderId';
import { getJsonRequestHeader } from 'owa-service/lib/ServiceRequestUtils';
import updateFolderOperation from 'owa-service/lib/operation/updateFolderOperation';
import type * as Schema from 'owa-graph-schema';
import { getMailboxRequestOptions } from 'owa-request-options-types';
import type { RequestOptions } from 'owa-service/src/RequestOptions';

export default function updateFolder(
    folderIdToUpdate: string,
    propertyUpdates: PropertyUpdate[],
    mailboxInfo: Schema.MailboxInfoInput,
    requestOptions?: RequestOptions
): Promise<FolderInfoResponseMessage> {
    return updateFolderOperation(
        {
            Header: getJsonRequestHeader(),
            Body: updateFolderRequest({
                FolderChanges: [
                    {
                        Updates: propertyUpdates,
                        FolderId: folderId({ Id: folderIdToUpdate }),
                    },
                ],
            }),
        },
        getMailboxRequestOptions(mailboxInfo, requestOptions)
    ).then(response => {
        return response.Body.ResponseMessages.Items[0];
    });
}
